
export const DISCOUNTRULETYPE_IsCollection = "IC";
export const DISCOUNTRULETYPE_OrderSize = "OS";
export const DISCOUNTRULETYPE_Break = "BR";

export const getDiscountName = (discountType) => {
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection: return "Is Collection";
        case DISCOUNTRULETYPE_OrderSize: return "Order Size";
        case DISCOUNTRULETYPE_Break: return "Multi Buy";
        default: return "";
    }
}

export const getSummaryName = (discountType) => {
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection: return "Collecting";
        case DISCOUNTRULETYPE_OrderSize: return "Order Size";
        case DISCOUNTRULETYPE_Break: return "Multi Buy";
        default: return "";
    }
}

export const getDiscountValue = (discount) => {
    const discountType = discount.type;
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection:
            return "Collecting";
        case DISCOUNTRULETYPE_OrderSize:
            return "£" + discount.min_amt + "+";
        case DISCOUNTRULETYPE_Break:
            return discount.break_val + "+";
        default:
            return "";
    }
}


export const orderedDiscountTypes = [
    DISCOUNTRULETYPE_IsCollection,
    DISCOUNTRULETYPE_OrderSize,
    DISCOUNTRULETYPE_Break
]
export const mapDiscountToList = (map) => {
    const list = [];
    for(const discountType of orderedDiscountTypes) {
        const items = map[discountType];
        if(items) {
            list.push({discountType, items});
        }
    }
    return list;
}
